export default "__VITE_ASSET__Deu_z9D8__"